<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* Canvas Mood - Judge.me dynamic review count format - 2026-09-02 */
(() => {
  const rootSelector = '#judgeme_product_reviews.jdgm-review-widget';
  const countSelector = '.jm-average-rating-display > .jm-cluster > .jm-text:last-of-type';

  const normalizeReviewCount = (root) => {
    root.querySelectorAll(countSelector).forEach((node) => {
      const match = node.textContent.trim().match(/^\(([\d,.]+)\s+(review|reviews)\)$/i);

      if (match) {
        node.textContent = match[1] + ' ' + match[2].toLowerCase();
      }
    });
  };

  const observeReviewWidget = () => {
    const root = document.querySelector(rootSelector);

    if (!root || root.dataset.cmReviewCountObserver === 'true') {
      return;
    }

    root.dataset.cmReviewCountObserver = 'true';
    normalizeReviewCount(root);

    new MutationObserver(() => normalizeReviewCount(root)).observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeReviewWidget, { once: true });
  } else {
    observeReviewWidget();
  }

  document.addEventListener('shopify:section:load', observeReviewWidget);
})();
